import styles from './index.module.less';
import { Collapse, CollapseProps, theme } from 'antd';
import { CSSProperties } from 'react';

interface IData {
  answer: string;
  question: string;
  id: number;
}

const Index = ({ data }: { data: any }) => {
  const dataList = data.faqList.content_list?.map((item: IData, index: number) => ({
    label: <h3 style={{ fontSize: '16px', lineHeight: '1.5rem' }}>{item.question}</h3>,
    // CMS 返回的 answer 本身是富文本（以 <p> 开头），外层不能再用 <p>，
    // 否则产出非法的 <p><p>…</p></p>，浏览器解析后 DOM 与 SSR 不一致，触发水合失败
    children: <div dangerouslySetInnerHTML={{ __html: item.answer }} />,
  }));
  const { token } = theme.useToken();

  const panelStyle: React.CSSProperties = {
    //   marginBottom: 24,
    //   background: "#0B0B0B",
    //   border: "1px solid rgba(68,68,68,0.87);",
    //     color: "rgba(255,255,255,0.6)",

    marginBottom: 24,
    background: `#ffffff`,
    borderRadius: token.borderRadiusLG,
    border: 'none',
    color: 'red',
    boxShadow: `0 0 2px #D9D9D9`,
  };

  const getItems: (panelStyle: CSSProperties) => CollapseProps['items'] = (panelStyle) => {
    return dataList?.map((item: IData, index: number) => {
      return {
        ...item,
        key: `${index}`,
        style: panelStyle,
        forceRender: true,
      };
    });
  };
  return (
    <div className={styles.container}>
      <h2>{data.contentInfo['section-faq']?.title}</h2>
      <div className={styles.main}>
        <Collapse
          className={styles.collapseContent}
          bordered={false}
          expandIconPosition="end"
          items={getItems(panelStyle)}
          defaultActiveKey={['0']}
        />
      </div>
    </div>
  );
};
export default Index;
